// @flow
import EnvConfig from 'config';
import { LocusApiModel } from 'common/modules/api';

export const provider = new LocusApiModel({
    baseUrl: EnvConfig.platformEndPoint,
    endPoint: `/provider/{providerId}`
});
